import { useEffect, useRef, type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { parserHtml } from 'shared/lib'
import { Typography } from 'shared/ui'
import { type Message } from 'entities/Message/model/Message'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { textToHtml } from 'entities/Message/lib/textToHtml'
import { parseMentionsTemplate, parseNoteBody } from 'entities/Message/lib/parseNote'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

type IBodyRawContentProps = {
  selectedSearch: string
  message: Message
}

export const BodyRawContent: FC<IBodyRawContentProps> = observer(({ message, selectedSearch }) => {
  const { body, isNote } = message
  const ref = useRef<HTMLDivElement>(null)
  const entities = useEntitiesContext()
  const { usersStore, attachmentStore } = entities
  const presentationStore = usePresentationModeContext()

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        const links = ref.current.querySelectorAll('a')
        links.forEach((link) => {
          const attachment = attachmentStore.getAttachmentByLink(link.href)
          if (attachment && attachment?.type !== 'attachment') {
            link.onclick = (e) => {
              e.preventDefault()
              presentationStore.setAttachments([attachment])
            }
          }
        })
      }
    }, 100)
  }, [attachmentStore.previousAttachmentMap.size, body])

  if (!body) return null

  let bodyParse = textToHtml(entities, {
    text: body,
    replaceNewRow: true,
    noReplaceMergeField: true,
  })
  if (!isNote) bodyParse = parseMentionsTemplate(bodyParse, usersStore.usersMap)
  bodyParse = parseNoteBody(bodyParse, usersStore.usersMap)

  return (
    <div ref={ref}>
      <Typography
        tag={'div'}
        variant={'body-rg-regular'}
        className={styles.text}
        ariaLabel={'body'}
      >
        {parserHtml(bodyParse, {
          search: selectedSearch,
        })}
      </Typography>
    </div>
  )
})
